"use strict";
import classNames from "classnames";
import Account from "../api/account";
import activityFormatter from "../formatters/activity";
import reactUtils from "../react_utils";
import generalFormatter from "../formatters/general";
import loadsService from "./loads_service";
import documentsService from "./documents_service";
import factorInvoicesService from "./factor_invoices_service";
import SimpleHtmlFormat from "./simple_html_format";
import CarrierName from "./carrier_name";
import FactorInvoiceHelper from "./factor_invoices";
import { Link } from "react-router";
import Auth from "../util/auth";
import DisablingButton from "../components/disabling_button";
import Transmissions from "../api/transmissions";
import React from "react";
import { assertType } from "./data/types/type_utilities";
var bem = reactUtils.makeBem("list-activity-stream");
const SentToCadenceActions = React.createClass(assertType({
  propTypes: {
    item: React.PropTypes.object.isRequired
  },
  getInitialState() {
    return {
      sending: false,
      sent: false,
      isUnapproved: false
    };
  },
  componentDidMount() {
    let factorInvoice = factorInvoicesService.getFetchedWithId(this.props.item.owner_id);
    let isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
    this.setState({ isUnapproved });
  },
  componentDidUpdate(prevProps) {
    if (this.props.item.owner_id !== prevProps.item.owner_id) {
      this.setState({ sent: false, sending: false });
    }
  },
  render() {
    const cadenceSuffix = `to CADENCE`;
    const buttonText = `Resend ${this.props.baseText} ${cadenceSuffix}`;
    const disabledText = `Resending ${this.props.baseText} ${cadenceSuffix}`;
    const sentText = `Resent ${this.props.baseText} ${cadenceSuffix}`;
    if (this.state.sent) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, sentText);
    } else if (this.state.isUnapproved) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, "Invoices have been un-approved and cannot be resent until re-approved");
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.send,
          disabled: this.state.sending,
          disabledText
        },
        buttonText
      ));
    }
  },
  send() {
    const component = this;
    this.setState({ sending: true });
    Transmissions.resend(this.props.item.data.transmission_id).then(() => {
      component.setState({ sending: false, sent: true });
    });
  }
}));
const ApprovalActions = React.createClass({
  propTypes: {
    item: React.PropTypes.object.isRequired
  },
  getInitialState() {
    return {
      unapproving: false,
      unapproved: false,
      purchased: false,
      useSendToReceivables: false,
      sendingToReceivables: false
    };
  },
  componentDidMount() {
    let factorInvoice = factorInvoicesService.getFetchedWithId(this.props.item.owner_id);
    let isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
    let isPurchased = factorInvoice.state == "purchased";
    let useSendToReceivables = Account.useSendToReceivables() && !factorInvoice.fuel_advance;
    this.setState({ unapproved: isUnapproved, purchased: isPurchased, useSendToReceivables });
  },
  factorInvoice() {
    factorInvoicesService.getFetchedWithId(this.props.item.owner_id);
  },
  render() {
    const buttonText = `Un-approve ${this.props.baseText}`;
    const disabledText = `Un-approving ${this.props.baseText}`;
    const unapprovedText = `Un-approved ${this.props.baseText}`;
    if (this.state.unapproved) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, unapprovedText);
    } else if (this.state.purchased) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, "This invoice has been marked as purchased. Contact support to un-approve.");
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.showUnapproveButton(buttonText, disabledText), this.sendToReceivablesButtonIf(this.state.useSendToReceivables));
    }
  },
  showUnapproveButton(buttonText, disabledText) {
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabledClassName: "button--disabled button--resend-to-cadence",
        className: "button--progress button--resend-to-cadence",
        onClick: this.unapprove,
        disabled: this.state.unapproving,
        disabledText
      },
      buttonText
    );
  },
  sendToReceivablesButtonIf(useSendToReceivables) {
    if (useSendToReceivables) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.sendToReceivables,
          disabled: this.state.sendingToReceivables,
          disabledText: "Sending to Receivables...."
        },
        "Mark as Purchased and Send to Receivables"
      );
    }
  },
  unapprove() {
    const component = this;
    this.setState({ unapproving: true });
    factorInvoicesService.unapproveInvoice(this.props.item.owner_id).then(() => {
      component.setState({ unapproving: false, unapproved: true });
    });
  },
  sendToReceivables() {
    const component = this;
    this.setState({ sendingToReceivables: true });
    factorInvoicesService.markInvoiceAsPurchased(this.props.item.owner_id).then(() => {
      component.setState({ sendingToReceivables: false, purchased: true });
    });
  }
});
const SentToBrokerTMSActions = React.createClass({
  propTypes: {
    item: React.PropTypes.object.isRequired
  },
  getInitialState() {
    return {
      sending: false,
      sent: false
    };
  },
  render() {
    const data = this.props.item.data;
    const baseText = `this invoice`;
    const buttonText = `Resend ${baseText}`;
    const disabledText = `Resending ${baseText}`;
    const sentText = `Resent ${baseText}`;
    if (this.state.sent) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, sentText);
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.send,
          disabled: this.state.sending,
          disabledText
        },
        buttonText
      ));
    }
  },
  send() {
    const component = this;
    this.setState({ sending: true });
    Transmissions.resend(this.props.item.data.transmission_id).then(() => {
      component.setState({ sending: false, sent: true });
    });
  }
});
const ExpandableCodeElement = React.createClass({
  getInitialState: function() {
    return {
      expanded: false
    };
  },
  toggle: function() {
    this.setState({ expanded: !this.state.expanded });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-code-value", onClick: this.toggle }, /* @__PURE__ */ React.createElement("code", null, this.value()));
  },
  value: function() {
    if (this.state.expanded) {
      return this.props.value;
    } else {
      return "Click to show.";
    }
  }
});
var ListActivityStream = React.createClass({
  getInitialState: function() {
    return {};
  },
  render: function() {
    if (_.isEmpty(this.props.items)) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box" }, "There is no activity for this search criteria.");
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: bem("__header") }, /* @__PURE__ */ React.createElement("div", { className: bem("__context") }, "Item"), /* @__PURE__ */ React.createElement("div", { className: bem("__title") }, "Title"), /* @__PURE__ */ React.createElement("div", { className: bem("__user") }, "User"), /* @__PURE__ */ React.createElement("div", { className: bem("__timestamp") }, "Time"), /* @__PURE__ */ React.createElement("div", { className: bem("__show-more") })), _.map(this.props.items, this.showSummaryItem));
    }
  },
  expand: function(item) {
    this.setState({ expanded: item });
  },
  contract: function(item) {
    this.setState({ expanded: void 0 });
  },
  showSummaryItem: function(item, index) {
    var formattedItem = activityFormatter.format(item);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: bem({ "__row": true, "__row--odd": index % 2 === 1 }),
        key: item.id
      },
      /* @__PURE__ */ React.createElement("div", { className: bem("__show-more") }, this.possibleExpander(item, formattedItem), "\xA0"),
      /* @__PURE__ */ React.createElement("div", { className: bem("__context") }, this.contextForItem(item)),
      /* @__PURE__ */ React.createElement("div", { className: bem("__title") }, formattedItem.title),
      /* @__PURE__ */ React.createElement("div", { className: bem("__user") }, formattedItem.user_name || "System", "\xA0"),
      /* @__PURE__ */ React.createElement("div", { className: bem("__timestamp") }, generalFormatter.shortDate(item.created_at), " ", generalFormatter.shortTime(item.created_at)),
      this.possibleExpandedBody(item, formattedItem)
    );
  },
  possibleExpandedBody: function(item, formattedItem) {
    if (this.isExpanded(item)) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(ActivityItemDetails, { formattedItem }));
    }
  },
  isExpanded: function(item) {
    return this.state.expanded && this.state.expanded.id === item.id;
  },
  possibleExpander: function(item, formattedItem) {
    if (formattedItem.body || formattedItem.labeled_elements && formattedItem.labeled_elements.length > 0) {
      if (this.isExpanded(item)) {
        return /* @__PURE__ */ React.createElement("a", { onClick: () => {
          this.contract(item);
        } }, /* @__PURE__ */ React.createElement("i", { className: "fi-minus" }));
      } else {
        return /* @__PURE__ */ React.createElement("a", { onClick: () => {
          this.expand(item);
        } }, /* @__PURE__ */ React.createElement("i", { className: "fi-plus" }));
      }
    }
  },
  contextForItem: function(item) {
    if (item.owner_type === "LoadState") {
      return this.contextForLoadState(item);
    } else if (item.owner_type === "TMS::Carrier") {
      return /* @__PURE__ */ React.createElement(CarrierName, { carrierID: item.owner_id });
    } else if (item.owner_type === "DocumentBatch") {
      return this.contextForDocumentBatch(item);
    } else if (item.owner_type === "CarrierInvoice") {
      return this.contextForCarrierInvoice(item);
    } else if (item.owner_type === "EmailMessage") {
      return this.contextForEmailMessage(item);
    } else if (item.owner_type === "FactorInvoice") {
      return this.contextForFactorInvoice(item);
    }
  },
  contextForEmailMessage: function(item) {
    var subject = void 0;
    if (item.data && item.data.subject) {
      subject = item.data.subject;
    } else {
      subject = "No Subject";
    }
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: bem("__main-context") }, "Email:\xA0 \u201C", /* @__PURE__ */ React.createElement(Link, { to: "/email/" + item.owner_id }, subject), "\u201D"));
  },
  contextForDocumentBatch: function(item) {
    var db = documentsService.getFetchedDocumentBatch(item.owner_id);
    var subject = void 0;
    if (_.str.isBlank(db.email_message.subject)) {
      subject = "No Subject";
    } else {
      subject = db.email_message.subject;
    }
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: bem("__main-context") }, "Email:\xA0 \u201C", /* @__PURE__ */ React.createElement(Link, { to: "/index-document-batches/" + db.id }, subject), "\u201D"), /* @__PURE__ */ React.createElement("span", { className: bem("__sub-context") }, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: db.carrier_id })));
  },
  contextForCarrierInvoice: function(item) {
    var loadState = _.first(loadsService.getLoadsByInvoiceIds([item.owner_id]));
    return this.loadStateCarrierInvoiceTemplate(loadState);
  },
  loadStateCarrierInvoiceTemplate: function(loadState) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: bem("__main-context") }, "Load: \xA0", /* @__PURE__ */ React.createElement(Link, { to: "/loads/" + loadState.id }, loadState.load.load_id)), /* @__PURE__ */ React.createElement("span", { className: bem("__sub-context") }, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: loadState.invoice_carrier_id || loadState.carrier_id })));
  },
  contextForLoadState: function(item) {
    var loadState = loadsService.getFetchedWithId(item.owner_id);
    return this.loadStateCarrierInvoiceTemplate(loadState);
  },
  contextForFactorInvoice: function(item) {
    var factorInvoice = factorInvoicesService.getFetchedWithId(item.owner_id);
    var documentBatchId = _.first(_.compact(factorInvoice.document_batch_ids));
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: bem("__main-context") }, "Factor Invoice: \xA0", /* @__PURE__ */ React.createElement(Link, { to: "/factor_invoices/" + item.owner_id }, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: factorInvoice.carrier_id }), " ", FactorInvoiceHelper.summary(factorInvoice))));
  }
});
var ActivityItemDetails = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, _.map(this.props.formattedItem.labeled_elements, this.showLabeledElement), this.possibleBody(this.props.formattedItem.body));
  },
  possibleBody: function(body) {
    if (body) {
      return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-full-body" }, /* @__PURE__ */ React.createElement(SimpleHtmlFormat, { text: body }));
    }
  },
  showCodeDetail: function(element) {
    const copyToClipboard = (str) => {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      element.hasBeenCopied = true;
      this.setState({ copied: true });
    };
    const message = element.hasBeenCopied ? "Data copied!" : "Copy to clipboard";
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button button--link",
        onClick: (_2) => copyToClipboard(element.code)
      },
      message
    ), /* @__PURE__ */ React.createElement(ExpandableCodeElement, { value: element.code }));
  },
  showValueDetail: function(element) {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, element.url ? this.detailLink(element) : element.value);
  },
  detailLink: function(element) {
    return /* @__PURE__ */ React.createElement("div", null, "\u201C", /* @__PURE__ */ React.createElement(Link, { to: element.url }, element.value), "\u201D");
  },
  showLabeledElement: function(element, index) {
    const detail = element.code ? this.showCodeDetail(element) : this.showValueDetail(element);
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line", key: "labeled-item-" + index }, element.hasOwnProperty("label") && this.showLabel(element.label), detail);
  },
  showLabel: function(label) {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, label);
  }
});
var ActivityStream = React.createClass({
  render: function() {
    let detail;
    if (_.isEmpty(this.props.items)) {
      detail = /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Activity is available.");
    } else {
      detail = _.map(this.props.items, this.showItem);
    }
    return /* @__PURE__ */ React.createElement("div", { className: "activity-items" }, detail);
  },
  showItem: function(item, index) {
    var formattedItem = activityFormatter.format(item);
    var hasDetail = formattedItem.labeled_elements && formattedItem.labeled_elements.length > 0 || formattedItem.body;
    var classes = classNames({
      "activity-item__container": true,
      "activity-item__container--detailed": hasDetail
    });
    return /* @__PURE__ */ React.createElement("div", { className: classes, key: "item-" + index }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__body" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__meta" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__user" }, formattedItem.user_name || "Temp User"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__timestamp" }, generalFormatter.shortDate(item.created_at), " ", generalFormatter.shortTime(item.created_at))), /* @__PURE__ */ React.createElement("div", { className: "activity-item__title" }, formattedItem.title), /* @__PURE__ */ React.createElement(ActivityItemDetails, { formattedItem }), this.possibleActions(item)));
  },
  possibleActions: function(item) {
    if (this.showSendToCadenceActions(item)) {
      return /* @__PURE__ */ React.createElement(SentToCadenceActions, { item, baseText: this.baseText(item) });
    } else if (this.showSendToBrokerTMSActions(item)) {
      return /* @__PURE__ */ React.createElement(SentToBrokerTMSActions, { item });
    } else if (this.showApprovalActions(item)) {
      return /* @__PURE__ */ React.createElement(ApprovalActions, { item, baseText: this.baseText(item) });
    }
  },
  baseText(item) {
    return `this invoice ${this.othersText(item)}`;
  },
  othersText(item) {
    const data = item.data;
    const othersCount = data.invoice_count - 1;
    const othersPlural = othersCount === 1 ? "other" : "others";
    return othersCount === 0 || isNaN(othersCount) ? "" : ` and ${othersCount} ${othersPlural} `;
  },
  showApprovalActions(item) {
    return item.activity_type === "approval" && item.owner_type === "FactorInvoice" && Auth._currentUser.admin;
  },
  showSendToCadenceActions(item) {
    return item.activity_type === "sent_to_cadence" && item.data.transmission_type === "cadence" && Auth._currentUser.admin;
  },
  showSendToBrokerTMSActions(item) {
    return item.data && item.data.transmission_id && item.data.transmission_type != "cadence" && item.data.transmission_type != "turvo_make_payment" && Auth._currentUser.admin;
  }
});
export { ListActivityStream, ActivityStream, ExpandableCodeElement, ActivityItemDetails };
